import React from "react";

const Slider = ({
  onSliderChange,
  sliderValue,
  setFormData,
  formData,
  min,
  max,
}) => {
  const handleSliderChange = (e) => {
    const value = Number(e.target.value);
    setFormData({ ...formData, sliderValue: value });
    onSliderChange(value);
  };
  
  return (
    <div className="flex items-center justify-center w-full">
      <input
        type="range"
        min={min}
        max={max}
        step={10}
        value={sliderValue}
        onChange={handleSliderChange}
        className="w-full h-100 bg-gray-200 rounded-lg appearance-none cursor-pointer"
      />
      <style>{`
         input[type="range"] {
            -webkit-appearance: none;
            appearance: none; 
            width: 100%;
            cursor: pointer;
            outline: none;
            overflow: hidden;
            border-radius: 25px;
            margin: 0px;
            background: transparent; 
        }

        input[type="range"]::-webkit-slider-runnable-track {
            height: 25px;
            background: #F3F3F3;
            border-radius: 25px;
        }

        input[type="range"]::-moz-range-track {
            height: 25px;
            background: #F3F3F3;
            border-radius: 25px;
        }

        input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none; 
            height: 25px;
            width: 25px;
            background-color: #fff;
            border-radius: 50%;
            border: 3px solid #FF2459;
            box-shadow: -102vw 0 0 99vw #FF2459;
        }

        input[type="range"]::-moz-range-thumb {
            height: 25px;
            width: 25px;
            background-color: #fff;
            border-radius: 50%;
            border: 3px solid #FF2459;
            box-shadow: -102vw 0 0 99vw #FF2459;
        }

        @media (min-width: 768px) {
          input[type="range"]::-webkit-slider-thumb {
              box-shadow: -101vw 0 0 100vw #FF2459;
          }

          input[type="range"]::-moz-range-thumb {
              box-shadow: -101vw 0 0 100vw #FF2459;
          }
      }
      `}</style>
    </div>
  );
};

export default Slider;
